export const newsStype = {
    GET_LAST_CARDI_ONE_NEWS: "GET-LAST-CARDI_ONE-NEWS",
    LOADING_NEWS_DATA: "LOADING_NEWS_DATA",
    TOTAL_NEWS_ITEMS:"TOTAL_NEWS_ITEMS",
    CLEAR_NEWS:"CLEAR_NEWS"
};
